/**
 * @desc 获取ebs汇率
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ExchangeRateResponse>;
export function request(body: defs.basics.ExchangeRateRequest, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getExchangeRate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
